export class VueGlobal {
  constructor () {
    this.name = 'VueGlobal'
    // 用户详情
    this.dataList = []
    this.user_info = {}
    this.optionsList = []
    this.getBookData = []
    this.optionsList2 = []
    this.video = []
    // // 学习记录
    // this.bookData = []
    // this.loginURL = 'http://192.168.15.220:8080/#/'
    this.loginURL = 'http://www.xmhgapi.com/train_login'
    this.iconUrl = 'http://www.xmhgapi.com/train_userImg/'
  }
  stringToJson (data) {
    if (typeof data === 'string') {
      try {
        const obj = JSON.parse(data)
        if (typeof obj === 'object' && obj) {
          return obj
        } else {
          return {}
        }
      } catch (e) {
        return {}
      }
    }
    return {}
  }
}



// WEBPACK FOOTER //
// ./src/global/index.js